import {NamedItem} from './named-item';
import {CameraConfiguration, HardwareConfiguration} from './vehicle.model';
import {DeviceInfo} from './device-info';

export class VehicleGroup implements NamedItem {
  constructor(public id: number,
              public title: string) {}
}

export class Vehicle {
  constructor(public id: number,
              public group: VehicleGroup,
              public label: string,
              public licensePlate: string,
              public hardwareConfiguration: HardwareConfiguration,
              public cameraConfiguration: CameraConfiguration,
              public deviceInfo?: DeviceInfo,
  ) {}
}

export enum StationaryNotificationType {
  NONE = 'NONE',
  LOGGED_IN_USERS = 'LOGGED_IN_USERS',
  SELECTED_RECIPIENTS = 'SELECTED_RECIPIENTS',
}

export class VehicleGroupStationaryConfiguration {
  maxStationaryTime?: number;
  notificationType?: StationaryNotificationType = StationaryNotificationType.LOGGED_IN_USERS;
  recipientEmails?: string[] = [];
}

export class VehicleCategoryModel {
  id: number;
  name: string;
  title: string;
  useDvir: boolean;
  allowRouteSelfAssign: boolean;
  preTripFormId?: number;
  postTripFormId?: number;
  showVehicles: boolean;
  showVehicleHistory: boolean;
  showVehicleObservations: boolean;
  stationaryConfiguration?: VehicleGroupStationaryConfiguration;
  observationTypeGroupIds: number[] = [];
  allowedRouteConfigIds: number[] = [];
  mobileConfiguration: VehicleGroupMobileConfiguration;
}

export class VehicleGroupMobileConfiguration {
  enabledCustomMapLayerIds: number[] = [];
  defaultBaseMap?: string;
  defaultHistoryTheme?: string;
  showTracksForVehicleGroupIds?: number[];
  showObservationsByObservationGroupIds?: number[];
}
